<template>
  <div class="wbk_wizard">
    <button class="btn-open-wizard" v-if="!isWizardOpen" @click="openWizard()">
      {{ translationHelper.getTranslation("wbk_Wizard_Btn_FindWB") }}
    </button>
    <div v-if="isWizardOpen" class="wbk_wizard_container">
      <a class="close-wizard" @click.stop="closeWizard()">
      </a>
      <form-wizard
        @on-complete="onComplete"
        @on-validate="handleValidation"
        @on-error="handleErrorMessage"
        title=""
        subtitle=""
        ref="wizard"
        :back-button-text="
          translationHelper.getTranslation('wbk_Wizard_Btn_Back')
        "
        :next-button-text="
          translationHelper.getTranslation('wbk_Wizard_Btn_Next')
        "
        :finish-button-text="
          translationHelper.getTranslation('wbk_Wizard_Btn_Finish')
        "
        color="#77C5D8"
        error-color="#ec5a7a"
      >
        <tab-content>
          <form @submit.prevent="nextStep">
            <p>
              {{
                translationHelper.getTranslation("wbk_Wizard_Question_Themes")
              }}
            </p>
            <input
              type="text"
              v-model="themaQuery"
              class="wbk_input"
              :class="{ disabled: hasExistingWbk }"
              :readonly="hasExistingWbk"
            />
            <div class="scfCheckboxBorder">
              <div class="scfCheckBoxListGeneralPanel">
                <span class="scfCheckbox">
                  <div
                    class="icheckbox_hslu icheck-item"
                    :class="{ checked: hasExistingWbk }"
                    @click="toggleExistingWbk()"
                  >
                    <input
                      id="existingWbk"
                      ref="cbxExistingWbk"
                      class="icheck-input"
                      type="checkbox"
                      :checked="hasExistingWbk"
                    />
                  </div>
                  <label
                    class="icheck-label"
                    for="existingWbk"
                    @click="toggleExistingWbk()"
                    >{{
                      translationHelper.getTranslation(
                        "wbk_Wizard_Label_AttendedEducation"
                      )
                    }}</label
                  >
                </span>
              </div>
            </div>
            <input type="submit" style="visibility: hidden" />
          </form>
        </tab-content>
        <tab-content
          v-if="hasExistingWbk"
          :before-change="validateFirstTabAsync"
        >
          <form @submit.prevent="nextStep">
            <v-select
              :clearable="false"
              class="style-chooser"
              v-if="hasExistingWbk"
              :options="possiblyCompletedCourses"
              label="name"
              v-model="selectedCompletedCourse"
              :placeholder="
                translationHelper.getTranslation(
                  'wbk_Wizard_Placeholder_AttendedEducation'
                )
              "
              :filterable="false"
              @search="onSearch"
            >
              <template slot="no-options">
                {{
                  translationHelper.getTranslation(
                    "wbk_Wizard_Placeholder_AttendedEducation"
                  )
                }}
              </template>
            </v-select>
            <div
              class="existingWbkNotFound"
              v-html="
                translationHelper.getTranslation(
                  'wbk_Wizard_ExistingWbk_NotFound'
                )
              "
            ></div>
            <input type="submit" style="visibility: hidden" />
          </form>
        </tab-content>

        <tab-content v-if="!hasExistingWbk">
          <form @submit.prevent="nextStep" v-if="themaQuery.length > 0">
            <h2>
              {{ translationHelper.getTranslation("wbk_Wizard_Title_Type") }}
            </h2>
            <p>
              {{ translationHelper.getTranslation("wbk_Wizard_Question_Type") }}
            </p>
            <template v-for="option in wbkTypes">
              <label
                class="wbk_option"
                v-tooltip.bottom-start="getTooltip(option)"
                ><input
                  class="wbk_input"
                  type="radio"
                  :value="option"
                  v-model="wbkType"
                /><span class="wbk_option_content">{{
                  getWbkTypeName(option)
                }}</span></label
              >
            </template>
            <input type="submit" style="visibility: hidden" />
          </form>
        </tab-content>
        <div v-if="errorMsg">
          <div class="error">{{ errorMsg }}</div>
        </div>
      </form-wizard>
    </div>
  </div>
</template>

<script>
import WBKonfigurator from "../../../../_Api/WBKonfigurator";

export default {
  props: {
    translationHelper: {
      type: Object,
    },
    isWizardOpen: {
      type: Boolean,
    },
  },
  data() {
    return {
      hasExistingWbk: false,
      existingWbkQuery: "",
      themaQuery: "",
      wbkType: "all",
      wbkTypes: ["all", "cas", "das", "mas", "emba-mba-dba"],
      possiblyCompletedCourses: [], // array of { id: 'guid', name: 'string' }
      selectedCompletedCourse: null,
      errorMsg: "",
    };
  },
  methods: {
    nextStep() {
      this.$refs.wizard.nextTab();
    },
    getTooltip(option) {
      var ttOptions = {
        content: this.translationHelper.getTranslation(
          "wbk_Wizard_Question_Type_" + option
        ),
        autoHide: true,
        classes: option !== "all" ? "visible" : "hidden",
      };
      return ttOptions;
    },
    toggleExistingWbk() {
      this.hasExistingWbk = !this.hasExistingWbk;
      this.$nextTick(() => {
        this.$refs.cbxExistingWbk.focus();
      });
    },
    getWbkTypeName(value) {
      if (!value) return "";
      switch (value) {
        case "all":
          return this.translationHelper.getTranslation("wbk_Wizard_All_Wb");
        default:
          return this.translationHelper.getTranslation(
            "wbk_Wizard_WB_Type_" + value
          );
      }
    },
    onComplete() {
      console.log("wizard completed");
      const completedCourseId = this.selectedCompletedCourse
        ? this.selectedCompletedCourse.id
        : "";
      const completedCourseTitle = this.selectedCompletedCourse
        ? this.selectedCompletedCourse.name
        : "";
      const queryParams = {
        hasExistingWbk: this.hasExistingWbk,
        themaQuery: this.themaQuery,
        completedCourseId: completedCourseId,
        completedCourseTitle: completedCourseTitle,
        wbkType: this.wbkType.toUpperCase(),
        loadAllCourses: false,
      };
      this.closeWizard();

      const url = new URL(window.location);
      url.searchParams.set("hasExistingWbk", queryParams.hasExistingWbk);
      url.searchParams.set("themaQuery", queryParams.themaQuery);
      url.searchParams.set("completedCourseId", queryParams.completedCourseId);
      url.searchParams.set(
        "completedCourseTitle",
        queryParams.completedCourseTitle
      );
      url.searchParams.set("wbkType", queryParams.wbkType);
      url.searchParams.set("loadAllCourses", queryParams.loadAllCourses);
      window.history.pushState({}, "", url);
      this.$emit("wizardFinished", queryParams);
    },
    handleValidation(isValid, tabIndex) {
      console.log("handle validation", { isValid, tabIndex });
    },
    handleErrorMessage(msg) {
      this.errorMsg = msg;
    },
    validateFirstTabAsync() {
      console.log("validate first tab");
      return new Promise((resolve, reject) => {
        if (this.hasExistingWbk && !this.selectedCompletedCourse) {
          reject(
            this.translationHelper.getTranslation(
              "wbk_Wizard_Validation_AttendedEducation"
            )
          );
        } else {
          resolve(true);
        }
      });
    },
    validateSecondTabAsync() {
      return new Promise((resolve, reject) => {
        if (this.themaQuery.length) {
          resolve(true);
        } else {
          reject(
            this.translationHelper.getTranslation(
              "wbk_Wizard_Validation_CannotBeEmpty"
            )
          );
        }
      });
    },
    onSearch(search, loading) {
      if (search.length) {
        loading(true);
        this.search(loading, search, this);
      }
    },
    openWizard() {
      this.$emit("wizard-open-change", true);
    },
    closeWizard() {
      this.$emit("wizard-open-change", false);
    },
    search: _.debounce((loading, search, vm) => {
      WBKonfigurator.getPossiblyCompletedCourses(search)
        .then((result) => {
          vm.possiblyCompletedCourses = result.data;
          console.log(
            "possible completed courses",
            vm.possiblyCompletedCourses
          );
          loading(false);
        })
        .catch((error) => {
          console.error(error);
          loading(false);
        });
    }, 350),
  },
};
</script>